var map = {
	"./gallery_00.jpg": 2084,
	"./gallery_01.jpg": 2085,
	"./gallery_02.jpg": 2086,
	"./gallery_03.jpg": 2087,
	"./gallery_04.jpg": 2088,
	"./gallery_05.jpg": 2089,
	"./gallery_06.jpg": 2090,
	"./gallery_07.jpg": 2091,
	"./gallery_08.jpg": 2092,
	"./gallery_09.jpg": 2093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2083;